import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { StorageService, TrackingPageLanguageMenu } from 'app/core';
import { getActiveLanguages } from 'app/helpers';

interface LanguageOption {
  code: string;
  name: string;
  active?: string;
}
@Component({
  selector: 'app-tracking-page-language-menu',
  templateUrl: './tracking-page-language-menu.component.html',
  styleUrls: ['./tracking-page-language-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageLanguageMenuComponent {
  @Input() languageMenu: TrackingPageLanguageMenu;
  @Input() selectedId: any;
  @Input() isVisualBuilder = true;
  @Input() isMobile = false;
  @Output() changeLanguage = new EventEmitter();
  @Output() selectBlock = new EventEmitter();

  selectedLanguage: string;
  languages: LanguageOption[] = getActiveLanguages();

  constructor(private storageService: StorageService) {
    this.updateSelectedLanguage();
  }

  get selectedLanguageTitle(): string {
    return this.languages.find((lang) => lang.code === this.selectedLanguage)
      .name;
  }

  selectLanguage() {
    if (!this.isVisualBuilder) {
      this.changeLanguage.emit(this.selectedLanguage);
    }
  }

  private updateSelectedLanguage() {
    this.selectedLanguage =
      this.storageService.getItem('selectedLocale') ||
      this.languageMenu?.defaultLan ||
      'en';
  }
}
